import styled from "styled-components";

export const Spinner = styled.div`
  width: 70px;
  text-align: center;
`;

export const Bounce = styled.div`
  width: 18px;
  height: 18px;
  background-color: #5d69e6;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;

  -webkit-animation-delay: ${props => (props.delay === 1 ? "-0.16s" : null)};
  animation-delay: ${props => (props.delay === 2 ? "-0.16s" : null)};

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;
